import r from "../managers/braze-instance.js";
export function getUser() {
  if (r.rr()) return r.gr();
}
